import { useEffect, useRef, useState } from "react";
import { useParams } from "react-router-dom";
import { API } from "../lib/api";
import { FormRenderer } from "../components/forms/FormRenderer";

export default function PublicForm() {
  const { id } = useParams();
  const [form, setForm] = useState(undefined);
  const [missing, setMissing] = useState("Form not found");
  const box = useRef(null);
  useEffect(() => { fetch(`${API}/public/forms/${id}`).then(async (r) => { if (r.ok) { setForm(await r.json()); } else { const d = await r.json().catch(() => ({})); setMissing(d.detail || "Form not found"); setForm(null); } }); }, [id]);
  useEffect(() => {
    if (window.parent === window) { return undefined; }
    const el = box.current;
    if (!el) { return undefined; }
    const send = () => window.parent.postMessage({ type: "bos-form-height", id, height: Math.ceil(el.getBoundingClientRect().height) }, "*");
    const ro = new ResizeObserver(send);
    ro.observe(el);
    send();
    return () => ro.disconnect();
  }, [id, form]);
  if (form === undefined) return null;
  if (!form) return <div className="min-h-screen grid place-items-center px-6 text-center text-muted-foreground" data-testid="public-form-missing">{missing}</div>;
  const submit = async (answers) => {
    const r = await fetch(`${API}/public/forms/${id}/submit`, { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ answers, consent: (form.fields || []).some((f) => f.type === "consent" && answers[f.key] === true) }) });
    const d = await r.json();
    return { ok: r.ok, message: r.ok ? d.message : typeof d.detail === "string" ? d.detail : "Submission failed" };
  };
  return <div ref={box} className={window.parent === window ? "min-h-screen" : ""} data-testid="public-form"><FormRenderer form={form} onSubmit={submit} embedded={window.parent !== window} /></div>;
}
